<template>
    <div
        class="LoadingSpinner pointer-events-none min-w-5"
        :class="{
            'fixed inset-0 z-[999] flex items-center justify-center': !notCentered && !position,
            'fixed left-1/2 top-[20%] z-[999] -translate-x-1/2': !notCentered && position === 'top',
            'fixed bottom-[20%] left-1/2 z-[999] -translate-x-1/2': !notCentered && position === 'bottom',
        }"
    >
        <SimpleSpinner :width="size" :height="size" />
    </div>
</template>

<script>
import SimpleSpinner from './SimpleSpinner.vue';

export default {
    components: { SimpleSpinner },
    props: {
        width: {
            type: [String, Number],
            required: false,
            default: null,
        },
        height: {
            type: [String, Number],
            required: false,
            default: null,
        },
        notCentered: {
            type: Boolean,
            required: false,
            default: false,
        },
        position: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        size() {
            const explicit = parseInt(this.width ?? this.height, 10);
            if (!Number.isNaN(explicit)) return explicit;
            // Inline spinners historically defaulted larger than the centered overlay.
            return this.notCentered ? 65 : 48;
        },
    },
};
</script>
